import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If already initialized and authenticated, allow
  if (authService.isInitialized() && authService.isAuthenticated()) {
    return true;
  }

  // If already initialized but not authenticated, redirect to login
  if (authService.isInitialized() && !authService.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }

  // Wait for initialization
  return authService.initialize().pipe(
    take(1),
    map((isAuthenticated) => {
      if (isAuthenticated) {
        return true;
      }

      return router.createUrlTree(['/auth/login']);
    }),
  );
};

